import React from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
export function FinalCTA() {
  return <section className="py-10 md:py-14 px-4 md:px-6 lg:px-8 bg-black" data-id="element-45">
      <div className="max-w-3xl mx-auto text-center" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} data-id="element-47">
          <h2 className="text-2xl md:text-3xl font-black text-white tracking-tight mb-6" data-id="element-48">
            Resumen de Todo Lo Que Recibís Hoy
          </h2>

          <div className="bg-white text-black rounded-2xl p-5 md:p-6 border-2 border-orange text-left shadow-sm" data-id="element-49">
            <div className="w-full max-w-sm mx-auto mb-5" data-id="element-50">
              <img src="https://cdn.magicpatterns.com/uploads/4urvcCGMNcreEMGzNkatxR/Mockup_Oferta.png" alt="Renovación Sin Obras — Sistema Completo" className="w-full h-auto rounded-lg" data-id="element-51" />
            </div>

            <div className="space-y-2 mb-5" data-id="element-52">
              <p className="text-sm md:text-base font-black border-b border-black/10 pb-2 leading-snug" data-id="element-53">
                Renovación Sin Obras — Sistema Completo (Método 4 Horas + Guía
                por Ambientes) —{' '}
                <span className="line-through text-black/40 font-bold" data-id="element-54">
                  <PriceDisplay amount={65990} data-id="element-55" />
                </span>
              </p>

              <p className="text-sm font-black text-orange pt-1" data-id="element-56">
                ⭐️ 5 Bonos Exclusivos Si Accedés Hoy
              </p>

              <ul className="space-y-1.5 font-medium text-xs md:text-sm" data-id="element-57">
                <li data-id="element-58">
                  📦 BONUS #1 — Lista de Materiales y Tiendas —{' '}
                  <span className="line-through text-black/40" data-id="element-59">
                    <PriceDisplay amount={28990} data-id="element-60" />
                  </span>
                </li>
                <li data-id="element-61">
                  🏠 BONUS #2 — Transformación 100% Reversible —{' '}
                  <span className="line-through text-black/40" data-id="element-62">
                    <PriceDisplay amount={23990} data-id="element-63" />
                  </span>
                </li>
                <li data-id="element-64">
                  📸 BONUS #3 — Efecto Pinterest —{' '}
                  <span className="line-through text-black/40" data-id="element-65">
                    <PriceDisplay amount={25990} data-id="element-66" />
                  </span>
                </li>
                <li data-id="element-67">
                  🧽 BONUS #4 — Fórmulas Anti-Manchas & Superficies Perfectas —{' '}
                  <span className="line-through text-black/40" data-id="element-68">
                    <PriceDisplay amount={18990} data-id="element-69" />
                  </span>
                </li>
                <li data-id="element-70">
                  💡 BONUS #5 — Iluminación Moderna Instantánea —{' '}
                  <span className="line-through text-black/40" data-id="element-71">
                    <PriceDisplay amount={22990} data-id="element-72" />
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-lightgray p-4 rounded-xl text-center mb-5 border border-black/5" data-id="element-73">
              <p className="text-black/50 font-bold mb-1 text-xs uppercase tracking-wider" data-id="element-74">
                VALOR TOTAL:
              </p>
              <p className="text-lg line-through text-black/40 mb-2 font-bold" data-id="element-75">
                <PriceDisplay amount={186940} data-id="element-76" />
              </p>

              <p className="text-xs font-black text-orange mb-1 uppercase tracking-wider" data-id="element-77">
                Hoy lo obtenés TODO por solo:
              </p>
              <p className="text-4xl font-black text-black mb-1 tracking-tighter" data-id="element-78">
                <PriceDisplay amount={19990} data-id="element-79" />
              </p>
              <p className="font-bold text-black text-xs uppercase tracking-wider" data-id="element-80">
                Pago Único. Sin Cargos Mensuales.
              </p>
            </div>

            <a href="https://bibliadigital.myshopify.com//cart/add?id=47688902443165&quantity=1" onClick={() => {
            if (typeof (window as any).fbq === 'function') (window as any).fbq('track', 'AddToCart');
          }} className="block w-full text-center bg-orange text-white font-black text-lg py-4 rounded-lg shadow-sm hover:shadow-md hover:scale-[1.02] transition-all duration-300 ease-out mb-2 uppercase tracking-wide" data-id="element-81">
              QUIERO MI RENOVACIÓN
            </a>

            <p className="text-center font-bold text-black/60 text-xs uppercase tracking-wider" data-id="element-82">
              Descarga Inmediata · Garantía 30 días
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}